import { EReportTemplateType } from '@timeedit/types';
import { TEDrawerSection } from '@timeedit/ui-components';
import Threshold from '../components/Threshold';
import type { TReportTemplateProps } from './ReportTemplate';

const Thresholds = ({ data, onChange }: TReportTemplateProps) => {
  return (
    <TEDrawerSection label="Thresholds">
      <div className="section-wrapper">
        <div className="section-col">
          {[
            EReportTemplateType.UTILIZATION,
            EReportTemplateType.HEATMAP,
          ].includes(data.templateType) && (
            <>
              <Threshold
                label="Frequency"
                threshold={data.frequencyThreshold}
                onChange={(val) => onChange('frequencyThreshold', val)}
              />
              <Threshold
                label="Occupancy"
                threshold={data.occupancyThreshold}
                onChange={(val) => onChange('occupancyThreshold', val)}
              />

              <Threshold
                label="Utilization"
                threshold={data.utilizationThreshold}
                onChange={(val) => onChange('utilizationThreshold', val)}
              />
            </>
          )}
          {data.templateType === EReportTemplateType.DEMAND_ANALYTIC && (
            <Threshold
              label="Demand"
              threshold={data.demandThreshold}
              onChange={(val) => onChange('demandThreshold', val)}
            />
          )}
        </div>
      </div>
    </TEDrawerSection>
  );
};

export default Thresholds;
